import type { TStudioLLMBlock } from '@conversed/rest/src/contracts/flow/flow.contract';
import type {
  DTOGetFlow,
  DTOGetFlowMenuEntries,
  DTOPutFlow,
} from '@conversed/shared/src/central/dto/flow.dto';

import type { TLLMBlockWithMetadata } from '@conversed/shared/src/central/types/blocks/LLMBlock';
import { ENDPOINTS } from '../constants/apiEndpoints';
import { axiosInterceptAccessTokenExpiry } from './axios/axiosIntercepted';
import type { TGeneralResponse } from './dto/common.dto';

export type { TStudioLLMBlock };

export const getBlocksApi = (
  revisionId?: string,
): TGeneralResponse<DTOGetFlow> => {
  const path = revisionId
    ? `${ENDPOINTS.FLOW.FLOW}/${revisionId}`
    : `${ENDPOINTS.FLOW.FLOW}`;
  return axiosInterceptAccessTokenExpiry().get(path);
};

export const getLLMBlocksApi = (): TGeneralResponse<
  TLLMBlockWithMetadata[]
> => {
  return axiosInterceptAccessTokenExpiry().get(ENDPOINTS.FLOW.LLM_BLOCKS);
};

export const getLLMBlocksByCompanyApi = (
  companyIds?: string[],
): TGeneralResponse<TStudioLLMBlock[]> => {
  return axiosInterceptAccessTokenExpiry().get(
    ENDPOINTS.FLOW.LLM_BLOCKS_BY_COMPANY,
    companyIds?.length
      ? { params: { companyIds: companyIds.join(',') } }
      : undefined,
  );
};

export const putBlocksApi = (
  blockUpdates: DTOPutFlow,
  revisionId: string,
): TGeneralResponse<TGeneralResponse> => {
  return axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.FLOW.FLOW}/${revisionId}`,
    blockUpdates,
  );
};

export const getFlowMenuEntriesApi =
  (): TGeneralResponse<DTOGetFlowMenuEntries> =>
    axiosInterceptAccessTokenExpiry().get(ENDPOINTS.FLOW.MENUENTRIES);
